export default __webpack_public_path__ + "assets/src/objects/House.gltf";